import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import { Modal25 } from '../../Modals/ModalSec2/Modal25'
import AddIcon from '@material-ui/icons/Add'
import { Button, Divider, Grid } from '@material-ui/core'
import { getTechnicalAssistanceBudget } from '../../../../../services/AsistenciaTecnica/get'
import NumberFormat from 'react-number-format'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useFormTechnicalAssistance } from '../../../../../context/TechnicalAssistanceContext'
import { useAsistencia } from '../../../../../context/AsistenciaContext'

export const Table25 = (props) => {
  const { IdCurrency, IdTechnicalAssistanceAnswer, formik } = props
  const { assistanceForm } = useFormTechnicalAssistance()
  const [open, setOpen] = useState(false)
  const [state] = useAsistencia()

  const initialState = [
    {
      IdTechnicalAssistanceAnswer: IdTechnicalAssistanceAnswer,
      Recurso: 'CambioResourceAmount',
      RecursosHumanos: 0,
      ConsultoriasServicios: 0,
      MaterialesInsumos: 0,
      ViaticosGastosViaje: 0,
      Otros: 0,
      Total: 0,
    },
    {
      IdTechnicalAssistanceAnswer: IdTechnicalAssistanceAnswer,
      Recurso: 'CounterpartAmount',
      RecursosHumanos: 0,
      ConsultoriasServicios: 0,
      MaterialesInsumos: 0,
      ViaticosGastosViaje: 0,
      Otros: 0,
      Total: 0,
    },
    {
      IdTechnicalAssistanceAnswer: IdTechnicalAssistanceAnswer,
      Recurso: 'CambioResourceAmount',
      RecursosHumanos: 0,
      ConsultoriasServicios: 0,
      MaterialesInsumos: 0,
      ViaticosGastosViaje: 0,
      Otros: 0,
      Total: 0,
    },
    {
      IdTechnicalAssistanceAnswer: IdTechnicalAssistanceAnswer,
      Recurso: 'CounterpartAmount',
      RecursosHumanos: 0,
      ConsultoriasServicios: 0,
      MaterialesInsumos: 0,
      ViaticosGastosViaje: 0,
      Otros: 0,
      Total: 0,
    },
  ]
  const [data, setData] = useState(initialState)
  const [sumRecursosHumanos, setSumRecursosHumanos] = useState(0)
  const [sumConsultoriasServicios, setSumConsultoriasServicios] = useState(0)
  const [sumMaterialesInsumos, setSumMaterialesInsumos] = useState(0)
  const [sumViaticosGastosViaje, setSumViaticosGastosViaje] = useState(0)
  const [sumOtros, setSumOtros] = useState(0)
  const [sumCambioResourceAmount, setSumCambioResourceAmount] = useState(0)
  const [sumCounterpartAmount, setsumCounterpartAmount] = useState(0)
  const [action, setAction] = useState('')

  const total = sumCambioResourceAmount + sumCounterpartAmount

  const resetState = () => {
    setData(initialState)
    setSumRecursosHumanos(0)
    setSumConsultoriasServicios(0)
    setSumMaterialesInsumos(0)
    setSumViaticosGastosViaje(0)
    setSumOtros(0)
    setSumCambioResourceAmount(0)
    setsumCounterpartAmount(0)
  }

  const getTechnicalAssistanceBudgetList = async () => {
    try {
      const response = await getTechnicalAssistanceBudget(
        IdTechnicalAssistanceAnswer,
      )
      if (response.Success) {
        if (response.Data.length === 0) resetState()
        if (response.Data.length > 0) {
          setData(response.Data)

          if (response.Data[0].Total === assistanceForm.RequestedAmount) {
            formik('validatePresupuesto', true)
          } else formik('validatePresupuesto', false)

          // response.Data.reduce((accumulator, object) => {

          //   setSumRecursosHumanos(accumulator + object[0].RecursosHumanos)
          //   return accumulator + object.RecursosHumanos
          // }, 0)

          setSumRecursosHumanos(
            response.Data[0].RecursosHumanos + response.Data[1].RecursosHumanos,
          )

          setSumConsultoriasServicios(
            response.Data[0].ConsultoriasServicios +
              response.Data[1].ConsultoriasServicios,
          )

          setSumMaterialesInsumos(
            response.Data[0].MaterialesInsumos +
              response.Data[1].MaterialesInsumos,
          )

          setSumViaticosGastosViaje(
            response.Data[0].ViaticosGastosViaje +
              response.Data[1].ViaticosGastosViaje,
          )

          setSumOtros(response.Data[0].Otros + response.Data[1].Otros)

          // response.Data.reduce((accumulator, object) => {
          //   setSumConsultoriasServicios(
          //     accumulator + object.ConsultoriasServicios,
          //   )
          //   return accumulator + object.ConsultoriasServicios
          // }, 0)

          // response.Data.reduce((accumulator, object) => {
          //   setSumMaterialesInsumos(accumulator + object.MaterialesInsumos)
          //   return accumulator + object.MaterialesInsumos
          // }, 0)

          // response.Data.reduce((accumulator, object) => {
          //   setSumViaticosGastosViaje(accumulator + object.ViaticosGastosViaje)
          //   return accumulator + object.ViaticosGastosViaje
          // }, 0)

          // response.Data.reduce((accumulator, object) => {
          //   setSumOtros(accumulator + object.Otros)
          //   return accumulator + object.Otros
          // }, 0)

          setSumCambioResourceAmount(
            response.Data[0].RecursosHumanos +
              response.Data[0].ConsultoriasServicios +
              response.Data[0].MaterialesInsumos +
              response.Data[0].ViaticosGastosViaje +
              response.Data[0].Otros,
          )

          setsumCounterpartAmount(
            response.Data[1].RecursosHumanos +
              response.Data[1].ConsultoriasServicios +
              response.Data[1].MaterialesInsumos +
              response.Data[1].ViaticosGastosViaje +
              response.Data[1].Otros,
          )

          if (response.Data[3].Total >= 10) {
            formik('validateTable25', true)
          } else formik('validateTable25', false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  // const percentRecursosHumanosCambioResourceAmount =
  //   data[0]?.RecursosHumanos !== 0
  //     ? (data[0]?.RecursosHumanos / total) * 100
  //     : 0
  // const percentConsultoriasServiciosCambioResourceAmount =
  //   data[0]?.ConsultoriasServicios !== 0
  //     ? (data[0]?.ConsultoriasServicios / total) * 100
  //     : 0
  // const percentMaterialesInsumosCambioResourceAmount =
  //   data[0]?.MaterialesInsumos !== 0
  //     ? (data[0]?.MaterialesInsumos / total) * 100
  //     : 0
  // const percentViaticosGastosViajeCambioResourceAmount =
  //   data[0]?.ViaticosGastosViaje !== 0
  //     ? (data[0]?.ViaticosGastosViaje / total) * 100
  //     : 0
  // const percentOtrosCambioResourceAmount =
  //   data[0]?.Otros !== 0 ? (data[0]?.Otros / total) * 100 : 0

  // const percentRecursosHumanosCounterpartAmount =
  //   data[1]?.RecursosHumanos !== 0
  //     ? (data[1]?.RecursosHumanos / total) * 100
  //     : 0
  // const percentConsultoriasServiciosCounterpartAmount =
  //   data[1]?.ConsultoriasServicios !== 0
  //     ? (data[1]?.ConsultoriasServicios / total) * 100
  //     : 0
  // const percentMaterialesInsumosCounterpartAmount =
  //   data[1]?.MaterialesInsumos !== 0
  //     ? (data[1]?.MaterialesInsumos / total) * 100
  //     : 0
  // const percentViaticosGastosViajeCounterpartAmount =
  //   data[1]?.ViaticosGastosViaje !== 0
  //     ? (data[1]?.ViaticosGastosViaje / total) * 100
  //     : 0
  // const percentOtrosCounterpartAmount =
  //   data[0]?.Otros !== 0 ? (data[0]?.Otros / total) * 100 : 0

  // const sumPercentCambioResourceAmount =
  //   percentRecursosHumanosCambioResourceAmount +
  //   percentConsultoriasServiciosCambioResourceAmount +
  //   percentMaterialesInsumosCambioResourceAmount +
  //   percentViaticosGastosViajeCambioResourceAmount +
  //   percentOtrosCambioResourceAmount

  // const sumPercentCounterpartAmount =
  //   percentRecursosHumanosCounterpartAmount +
  //   percentConsultoriasServiciosCounterpartAmount +
  //   percentMaterialesInsumosCounterpartAmount +
  //   percentViaticosGastosViajeCounterpartAmount +
  //   percentOtrosCounterpartAmount

  useEffect(() => {
    if (IdTechnicalAssistanceAnswer !== undefined && state.step === 2) {
      getTechnicalAssistanceBudgetList()
    }
  }, [IdTechnicalAssistanceAnswer, state.step])

  const dataTable = [
    {
      id: 1,
      MaterialesInsumos: 'Recursos CAMBIO II',
    },
    {
      id: 2,
      RecursosHumanos: data[0]?.RecursosHumanos,
      ConsultoriasServicios: data[0]?.ConsultoriasServicios,
      MaterialesInsumos: data[0]?.MaterialesInsumos,
      ViaticosGastosViaje: data[0]?.ViaticosGastosViaje,
      Otros: data[0]?.Otros,
      name: 'Monto',
      parentId: 1,
      total: data[0]?.Total,
    },
    {
      id: 3,
      RecursosHumanos: data[2]?.RecursosHumanos,
      ConsultoriasServicios: data[2]?.ConsultoriasServicios,
      MaterialesInsumos: data[2]?.MaterialesInsumos,
      ViaticosGastosViaje: data[2]?.ViaticosGastosViaje,
      Otros: data[2]?.Otros,
      name: '%',
      parentId: 1,
      total: data[2]?.Total,
    },
    {
      id: 5,
      MaterialesInsumos: 'Recursos Contraparte',
    },
    {
      id: 6,
      RecursosHumanos: data[1]?.RecursosHumanos,
      ConsultoriasServicios: data[1]?.ConsultoriasServicios,
      MaterialesInsumos: data[1]?.MaterialesInsumos,
      ViaticosGastosViaje: data[1]?.ViaticosGastosViaje,
      Otros: data[1]?.Otros,
      parentId: 5,
      total: data[1]?.Total,
      name: 'Monto',
    },
    {
      id: 4,
      RecursosHumanos: data[3]?.RecursosHumanos,
      ConsultoriasServicios: data[3]?.ConsultoriasServicios,
      MaterialesInsumos: data[3]?.MaterialesInsumos,
      ViaticosGastosViaje: data[3]?.ViaticosGastosViaje,
      Otros: data[3]?.Otros,
      parentId: 5,
      total: data[3]?.Total,
      name: '%',
    },
  ]
  const columns = [
    {
      title: '',
      field: 'name',
      align: 'center',
      render: (expense) => (
        <>
          <b>{expense.name}</b>
        </>
      ),
    },
    {
      title: 'Recursos Humanos',
      field: 'RecursosHumanos',
      align: 'right',
      render: (expense) => (
        <>
          <NumberFormat
            value={expense.RecursosHumanos}
            thousandSeparator={true}
            decimalScale={2}
            displayType={'text'}
            isNumericString={true}
            fixedDecimalScale
          />
        </>
      ),
    },
    {
      title: 'Consultorías y Servicios',
      field: 'ConsultoriasServicios',
      align: 'right',
      render: (expense) => (
        <>
          <NumberFormat
            value={expense.ConsultoriasServicios}
            thousandSeparator={true}
            decimalScale={2}
            displayType={'text'}
            isNumericString={true}
            fixedDecimalScale
          />
        </>
      ),
    },
    {
      title: 'Materiales e Insumos',
      field: 'MaterialesInsumos',
      align: 'right',
      render: (expense) => (
        <>
          {typeof expense.MaterialesInsumos === 'string' ? (
            <b>{expense.MaterialesInsumos}</b>
          ) : (
            <NumberFormat
              value={expense.MaterialesInsumos}
              thousandSeparator={true}
              decimalScale={2}
              displayType={'text'}
              isNumericString={true}
              fixedDecimalScale
            />
          )}
        </>
      ),
    },
    {
      title: 'Viáticos / Gastos viaje',
      field: 'ViaticosGastosViaje',
      align: 'right',
      render: (expense) => (
        <>
          <NumberFormat
            value={expense.ViaticosGastosViaje}
            thousandSeparator={true}
            decimalScale={2}
            displayType={'text'}
            isNumericString={true}
            fixedDecimalScale
          />
        </>
      ),
    },
    {
      title: 'Otros',
      field: 'Otros',

      align: 'right',
      render: (expense) => (
        <>
          <NumberFormat
            value={expense.Otros}
            thousandSeparator={true}
            decimalScale={2}
            displayType={'text'}
            isNumericString={true}
            fixedDecimalScale
          />
        </>
      ),
    },
    {
      title: 'Total',
      field: 'total',
      align: 'right',
      render: (expense) => (
        <>
          <NumberFormat
            value={expense.total}
            thousandSeparator={true}
            decimalScale={2}
            displayType={'text'}
            isNumericString={true}
            fixedDecimalScale
          />
        </>
      ),
    },
  ]

  const data2 = [
    {
      FieldDescription: 'Total',
      RecursosHumanos: sumRecursosHumanos,
      ConsultoriasServicios: sumConsultoriasServicios,
      MaterialesInsumos: sumMaterialesInsumos,
      ViaticosGastosViaje: sumViaticosGastosViaje,
      Otros: sumOtros,
      Total: total,
    },
  ]

  const columns2 = [
    {
      title: 'Categoría',
      field: 'FieldDescription',
      sorting: false,
      filtering: false,
      align: 'center',
    },
    {
      title: 'Recursos Humanos',
      field: 'RecursosHumanos',
      align: 'right',
      render: (expense) => (
        <>
          {typeof expense.RecursosHumanos === 'string' ? (
            <b>{expense.RecursosHumanos}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.RecursosHumanos}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
    {
      title: 'Costo Total',
      field: 'ConsultoriasServicios',
      align: 'right',

      render: (expense) => (
        <>
          {typeof expense.ConsultoriasServicios === 'string' ? (
            <b>{expense.ConsultoriasServicios}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.ConsultoriasServicios}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
    {
      title: 'MaterialesInsumos',
      field: 'MaterialesInsumos',
      align: 'right',
      render: (expense) => (
        <>
          {typeof expense.MaterialesInsumos === 'string' ? (
            <b>{expense.MaterialesInsumos}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.MaterialesInsumos}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
    {
      title: 'MIPYME',
      field: 'ViaticosGastosViaje',
      align: 'right',
      render: (expense) => (
        <>
          {typeof expense.ViaticosGastosViaje === 'string' ? (
            <b>{expense.ViaticosGastosViaje}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.ViaticosGastosViaje}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
    {
      title: 'Otros Aportes',
      field: 'Otros',
      align: 'right',
      render: (expense) => (
        <>
          {typeof expense.Otros === 'string' ? (
            <b>{expense.Otros}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.Otros}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
    {
      title: 'Otros Aportes',
      field: 'Total',
      align: 'right',
      render: (expense) => (
        <>
          {typeof expense.Total === 'string' ? (
            <b>{expense.Total}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.Total}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
  ]
  return (
    <>
      <Grid container spacing={1} style={{ height: '550px' }}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            title=""
            style={{ height: '70%' }}
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                  >
                    Agregar
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
                onClick: () => {
                  setOpen(true)
                  setAction('add')
                },
              },
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={{ backgroundColor: '#0d53ad', color: '#FFFFFF' }}
                    startIcon={<EditIcon style={{ color: 'white' }} />}
                  >
                    Modificar
                  </Button>
                ),
                tooltip: 'Modificar',
                position: 'toolbar',
                onClick: () => {
                  setOpen(true)
                  setAction('edit')
                },
              },
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={{ backgroundColor: 'red', color: '#FFFFFF' }}
                    startIcon={<DeleteIcon style={{ color: 'white' }} />}
                  >
                    Eliminar
                  </Button>
                ),
                tooltip: 'Eliminar',
                position: 'toolbar',
                onClick: () => {
                  setOpen(true)
                  setAction('delete')
                },
              },
            ]}
            data={dataTable}
            columns={columns}
            options={{
              selection: false,
              toolbarButtonAlignment: 'left',
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
              defaultExpanded: true,
              pageSizeOptions: [2, 5, 10, 11],
              pageSize: 11,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',
              exportButton: true,
              paging: true,
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            components={{
              Pagination: (props) => (
                <div style={{ marginTop: '-250px' }}>
                  <Divider style={{ background: 'black' }} variant="middle" />
                  <Divider style={{ background: 'black' }} variant="middle" />
                  <div>
                    <MaterialTable
                      columns={columns2}
                      data={data2}
                      options={{
                        toolbar: false,
                        header: false,
                        paging: false,
                        rowStyle: {
                          fontWeight: 'bold',
                        },
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </Grid>
        <Modal25
          open={open}
          setOpen={setOpen}
          IdCurrency={IdCurrency}
          getTechnicalAssistanceBudgetList={getTechnicalAssistanceBudgetList}
          action={action}
          IdTechnicalAssistanceAnswer={IdTechnicalAssistanceAnswer}
        />
      </Grid>
    </>
  )
}
